module.exports = __webpack_public_path__ + "img/9fe1d26eaff98c35829f1d1645805a28eeec158c_hq.jpg";